import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "@/lib/utils"

const badgeVariants = cva(
  "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-primary text-primary-foreground hover:bg-primary/90",
        secondary:
          "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80",
        destructive:
          "border-transparent bg-destructive/10 text-destructive dark:bg-destructive/20",
        outline: "border-border text-foreground",
        // Soft tinted status pills (Chroma)
        success:
          "border-transparent bg-success/10 text-success dark:bg-success/20",
        warning:
          "border-transparent bg-warning/10 text-warning dark:bg-warning/20",
        info: "border-transparent bg-speaker-5/10 text-speaker-5 dark:bg-speaker-5/20",
        // Semantic status aliases matching product states
        ready:
          "border-transparent bg-success/10 text-success dark:bg-success/20",
        processing:
          "border-transparent bg-warning/10 text-warning dark:bg-warning/20",
        live: "border-transparent bg-speaker-1/10 text-speaker-1 dark:bg-speaker-1/20",
        failed:
          "border-transparent bg-destructive/10 text-destructive dark:bg-destructive/20",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  )
}

export { Badge, badgeVariants }
